(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nl-accessory-product"] && !Shopify.designMode) return;
  try {
    
const bindAccessory=(scope=document)=>scope.querySelectorAll('[data-nl-accessory]').forEach(section=>{if(section.dataset.bound)return;section.dataset.bound='true';const select=section.querySelector('[data-accessory-variant]');if(!select)return;const data=JSON.parse(section.querySelector('[data-accessory-data]').textContent);select.addEventListener('change',()=>{const variant=data.variants.find(item=>String(item.id)===select.value);if(!variant)return;section.querySelector('[data-accessory-price]').textContent=variant.price;const button=section.querySelector('[data-accessory-submit]');button.disabled=!variant.available;button.textContent=variant.available?data.add:data.soldOut;const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);});});bindAccessory();document.addEventListener('shopify:section:load',event=>bindAccessory(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nl-reviews"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const cards=root=>[...root.querySelectorAll('[data-review-card]')];
  const updateNavigation=root=>{
    const track=root.querySelector('[data-review-track]');
    const overflow=track.scrollWidth>track.clientWidth+2;
    root.querySelector('[data-review-navigation]').hidden=!overflow;
    track.tabIndex=overflow?0:-1;
    root.querySelector('[data-review-step="-1"]').disabled=track.scrollLeft<=2;
    root.querySelector('[data-review-step="1"]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
  };
  const filter=(root,category)=>{
    root.querySelectorAll('[data-review-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.reviewFilter===category)));
    cards(root).forEach(card=>card.hidden=card.dataset.category!==category);
    const count=cards(root).filter(card=>!card.hidden).length;
    root.querySelector('[data-review-empty]').hidden=count!==0;
    const status=root.querySelector('[data-review-status]');
    status.textContent=status.dataset.countTemplate.replace('[count]',String(count));
    root.querySelector('[data-review-track]').scrollLeft=0;
    requestAnimationFrame(()=>updateNavigation(root));
  };
  const init=(scope=document)=>{
    const roots=[...(scope.matches?.('[data-nl-reviews]')?[scope]:[]),...scope.querySelectorAll('[data-nl-reviews]')];
    roots.forEach(root=>{
      if(root.dataset.reviewsBound)return;
      root.dataset.reviewsBound='true';
      filter(root,root.querySelector('[data-review-filter][aria-pressed=true]')?.dataset.reviewFilter||'1');
      root.querySelector('[data-review-track]').addEventListener('scroll',()=>updateNavigation(root),{passive:true});
      new ResizeObserver(()=>updateNavigation(root)).observe(root);
    });
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-review-filter],[data-review-step]');
    if(!button)return;
    const root=button.closest('[data-nl-reviews]');
    if(button.dataset.reviewFilter){filter(root,button.dataset.reviewFilter);return;}
    const track=root.querySelector('[data-review-track]');
    const card=cards(root).find(card=>!card.hidden);
    const distance=card?card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap):track.clientWidth;
    track.scrollBy({left:Number(button.dataset.reviewStep)*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:block:select',event=>{
    const root=event.target.closest('[data-nl-reviews]');
    if(!root)return;
    const card=cards(root).find(card=>card.dataset.blockId===event.detail.blockId);
    if(!card)return;
    filter(root,card.dataset.category);
    requestAnimationFrame(()=>card.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'}));
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nl-solution"] && !Shopify.designMode) return;
  try {
    
(()=>{const set=(box,p)=>{p=Math.min(100,Math.max(0,p));box.style.setProperty('--pos',p+'%');const r=box.querySelector('input');if(r)r.value=Math.round(p)};document.addEventListener('pointerdown',e=>{const box=e.target.closest&&e.target.closest('.nl-ba');if(!box||e.button>0)return;box.dataset.touched='1';const move=ev=>{const k=box.getBoundingClientRect();set(box,(ev.clientX-k.left)/k.width*100)};move(e);const stop=()=>{removeEventListener('pointermove',move);removeEventListener('pointerup',stop);removeEventListener('pointercancel',stop)};addEventListener('pointermove',move);addEventListener('pointerup',stop);addEventListener('pointercancel',stop)});document.addEventListener('input',e=>{if(e.target.matches&&e.target.matches('.nl-ba input')){const box=e.target.closest('.nl-ba');box.dataset.touched='1';set(box,+e.target.value)}});const hint=box=>{if(box.dataset.touched||matchMedia('(prefers-reduced-motion: reduce)').matches)return;const from=parseFloat(box.style.getPropertyValue('--pos'))||60,to=Math.max(8,from-38),t0=performance.now(),d=1800;const step=t=>{if(box.dataset.touched)return;const k=Math.min(1,(t-t0)/d);set(box,from+(to-from)*(1-Math.cos(k*2*Math.PI))/2);if(k<1)requestAnimationFrame(step)};requestAnimationFrame(step)};const init=()=>{if(!('IntersectionObserver'in window))return;const io=new IntersectionObserver(es=>es.forEach(en=>{if(en.isIntersecting){io.unobserve(en.target);setTimeout(()=>hint(en.target),400)}}),{threshold:.6});document.querySelectorAll('.nl-ba').forEach(b=>io.observe(b))};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init()})();

  } catch(e) { console.error(e); }
})();
})();
